export const LOCAL_STORAGE_PRESENTAION_USER_INFO_KEY = 'presentation_user_info_key';
